import { Fragment } from "preact";
import Center from "../../../../components/center";
import Editorial from "../../../../components/editorial";
import Head from "../../../../components/head";
import Hero from "../../../../components/hero";
import CandidateBio from "../../../../components/candidate-bio";

const candidate = {
  name: "Rachel Long",
  since: 1991,
  email: "Rachel4Klahanie@gmail.com",
  photo: "/images/candidates/rachel-long.jpg",
};

const pageTitle = `2025 - ${candidate.name} - Klahanie.info`;

const questions = [
  {
    question: "Why you are interested in joining the Board of Directors?",
    answer: (
      <p>
        Klahanie has been my home for over 33 years, where my husband Scott and
        I raised our family. Now that our children are successfully launched, I
        have the time, energy, and enthusiasm to make a meaningful contribution
        to our community.
      </p>
    ),
  },
  {
    question: "What do you see as the Klahanie Board’s top priority?",
    answer: (
      <p>
        The Board’s top priority should be regaining the trust of all homeowners
        and fostering a stronger sense of unity among neighbors. It’s essential
        that the Board listens to differing opinions and makes decisions that
        reflect the collective desires of the community. Increasing`
        transparency and improving communication will be key areas of focus for
        me.
      </p>
    ),
  },
  {
    question:
      "What areas of focus would you like to see the Klahanie Board address during your term?",
    answer: (
      <Fragment>
        <p>
          We should{" "}
          <strong>
            pause the current plan to spend between $9,000,000 and $12,000,000+
          </strong>{" "}
          for an expanded pool, HOA office, and community room and first obtain
          homeowner input via a vote or survey with estimated costs attached.{" "}
          <strong>Homeowners’ interest alone</strong> should dictate the
          direction that the board takes to address the aging Mountainview Pool
          and HOA office. The Bylaw that was changed in 2023 - without homeowner
          approval - to grant full authority to the Board to spend millions of
          dollars must be modified to restrict the power of the Board and return
          power to the homeowners.
        </p>
        <p>
          The Board must prioritize maintaining Klahanie’s aging amenities—such
          as landscaping, trails, open spaces, and sports facilities—while
          ensuring that costs for homeowners are controlled. As an aging
          community, some of Klahanie’s amenities will require updating,
          repairs, or replacements. The Board should approach this task with the
          goal of preserving Klahanie as the premier community on the plateau
          while ensuring that these improvements are made in a fiscally
          responsible and transparent way. Additionally, it is important that
          the Board engages homeowners throughout this process.
        </p>
        <p>
          I would also like the Board to focus on finding innovative ways to
          reconnect homeowners and revive a true sense of neighborhood. Klahanie
          was originally designed in the 1980s as a “small town community” where
          residents would feel welcomed and at home. While we do a great job
          organizing large community events, I’d love to see more small-scale,
          neighbor-focused activities. This could include promoting programs
          such as Neighborhood Watch, block parties, or other “get to know your
          neighbors” initiatives.
        </p>
      </Fragment>
    ),
  },
  {
    question:
      "What knowledge and experience will you bring to the Klahanie Board?",
    answer: (
      <p>
        I am highly organized, driven, and a strong communicator. I excel at
        staying calm in stressful situations and have a deep respect for
        differing opinions. I believe that everyone has something valuable to
        contribute, and I am committed to fostering an open line of
        communication and compromise to resolve conflicts. My goal is to help
        bridge divides and alleviate the stress currently affecting our
        community.
      </p>
    ),
  },
  {
    question: "Please share your background, work history, and skill set.",
    answer: (
      <Fragment>
        <p>
          I have degrees in Economics and Computer Science and spent the first
          few years of my career working in Economic Research at the Federal
          Reserve. I then enjoyed a successful career in Sales Management at
          AT&amp;T before moving to AT&amp;T Wireless, where I was a Senior
          Director in Offer Development. Throughout my business career, I was
          recognized for my leadership skills and was able to hone those skills
          through training and special projects. A notable achievement was when
          I was selected to work with the executive team to facilitate a complex
          company merger. This involved uniting diverse groups in a
          collaborative environment to ensure a smooth transition with minimal
          turnover.
        </p>
        <p>
          Eventually, I left the corporate world to focus on our family. During
          this time, I volunteered in Issaquah schools and with my children’s
          sports clubs, and I organized parent groups to advocate for students’
          interests.
        </p>
        <p>
          In summary, I believe my collaborative approach, leadership
          experience, and community involvement make me a strong candidate for
          the Klahanie Board. I look forward to the opportunity to serve and
          contribute to our home community.
        </p>
      </Fragment>
    ),
  },
];

const RachelLong = () => (
  <Editorial>
    <Head title={pageTitle} />
    <Hero background="/images/backgrounds/forest-path.jpg">
      <h1>
        <span style="font-size: 0.5em; font-weight: 400; display: block; margin-bottom: 0.25em; text-transform: none;">
          Vote for{" "}
        </span>
        {candidate.name}
      </h1>
      <h2 style="font-size: 1.1em; font-weight: 400;">
        <span>Klahanie resident since {candidate.since}</span>
      </h2>
    </Hero>
    <div>
      <Center>
        <CandidateBio
          img={candidate.photo}
          name={candidate.name}
          since={candidate.since}
          email={candidate.email}
          questions={questions}
        >
          <p>
            Klahanie has been my home for over 33 years, where my husband,
            Scott, and I raised our family. Now that our children are grown, I’m
            eager to give back by serving on the Klahanie Board.
          </p>
          <p>
            I have degrees in Economics and Computer Science and began my
            professional career in{" "}
            <strong>Economic Research at the Federal Reserve</strong>. I then
            moved on to a successful career in{" "}
            <strong>Sales Management at AT&amp;T</strong> and as a{" "}
            <strong>
              Senior Director in Offer Development at AT&amp;T Wireless
            </strong>
            . I’ve managed complex projects, united diverse teams, and navigated
            organizational change, always prioritizing collaboration and
            transparency.
          </p>
          <p>
            The Board’s priority should be{" "}
            <strong>rebuilding homeowner’s trust</strong> and fostering unity by
            listening to diverse perspectives and making transparent,
            community-driven decisions. Improving communication will strengthen
            our neighborhood. We should{" "}
            <strong>
              pause the current plan to spend between $9,000,000 and
              $12,000,000+
            </strong>{" "}
            for an expanded pool, HOA office, and community room and first
            obtain homeowner input via a vote or survey with estimated costs
            attached. <strong>Homeowners’ interest alone</strong> should dictate
            the direction that the board takes to address the aging Mountainview
            Pool and HOA office. The Bylaw that was changed in 2023 - without
            homeowner approval - to grant full authority to the Board to spend
            millions of dollars must be modified to restrict the power of the
            Board and return power to the homeowners.
          </p>
          <p>
            Klahanie must maintain its aging amenities—landscaping, trails, open
            spaces, and sports facilities—while managing costs. As updates and
            repairs are needed, the Board must handle these projects with{" "}
            <strong>fiscal responsibility and homeowner engagement</strong>. I’d
            also like to reconnect homeowners and revive a sense of community
            with more small-scale activities like Neighborhood Watch and block
            parties to foster deeper connections.
          </p>
          <p>
            I am organized, a strong communicator and excel in stressful
            situations. Everyone has something valuable to contribute, and I am
            committed to fostering open communication and compromise. My
            collaborative approach, leadership experience, and community
            involvement make me a strong candidate for the Klahanie Board.
          </p>
        </CandidateBio>
      </Center>
    </div>
  </Editorial>
);

export default RachelLong;
